import { GoalsInput } from '@cpd-app/generated';

/**
 * CPD-679 (Phong, 29 Sep 2026). WHAT A PROGRAM WRITE DOES TO THE SCHOOL.
 *
 * The school was chosen for the program: the school list is filtered to the
 * program's schools, and OCC.5 re-points the program at that school's own row.
 * Changing or removing the program while the school stayed paired the school
 * with a degree it may not teach, which OCC.5 exists to prevent (Jackson,
 * 24 Sep 2026).
 *
 * - Removing the program (a null id) clears the school, even when the caller
 *   re-sends it: the report pages pass the held school id with their remove.
 * - Choosing a program with no school clears the school. The occupation page
 *   first asks whether the held school teaches the new program, and names the
 *   school here when it does, which keeps it.
 * - Choosing a program AT a school sets both, as before.
 *
 * History: `programsByOccupation` returns `schoolId: null` on every row, so
 * the occupation page's list calls this with no school. That once cleared a
 * held school by accident (an undefined key became a null on the wire), and
 * the fix kept the school. It is now cleared on purpose.
 */
export function programGoalChange(
  schoolId: number | string | null | undefined,
  schoolProgramId: number | null | undefined,
  schoolProgramEdLevelId: number | null | undefined
): Pick<GoalsInput, 'schoolId' | 'schoolProgramId' | 'schoolProgramEdLevelId'> {
  if (schoolProgramId == null) {
    return { schoolId: null, schoolProgramId: null, schoolProgramEdLevelId: null };
  }
  return {
    schoolId: schoolId == null ? null : Number(schoolId),
    schoolProgramId,
    schoolProgramEdLevelId: schoolProgramEdLevelId ?? null
  };
}
